function initTestimonialsSlider() {
  const sliders = document.querySelectorAll('[data-testimonials-slider]');
  if (!sliders.length) return;

  sliders.forEach(slider => {
    const track = slider.querySelector('[data-testimonials-track]');
    if (!track) return;

    const prevBtn = slider.querySelector('[data-testimonials-prev]');
    const nextBtn = slider.querySelector('[data-testimonials-next]');

    const getStep = () => Math.max(track.clientWidth * 0.8, 280);

    const scrollByDir = dir => {
      track.scrollBy({ left: dir * getStep(), behavior: 'smooth' });
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 5;
      if (prevBtn)
        prevBtn.disabled = track.scrollLeft <= 5;
      if (nextBtn)
        nextBtn.disabled = track.scrollLeft >= maxScroll;
    };

    prevBtn?.addEventListener('click', () => scrollByDir(-1));
    nextBtn?.addEventListener('click', () => scrollByDir(1));

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateButtons);
    });
    window.addEventListener('resize', updateButtons);

    updateButtons();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
} else {
  initTestimonialsSlider();
}
